import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	closeSidebarNonFinal: {
		id: 'admin-pages-common.sidebar.close-sidebar-non-final',
		defaultMessage: 'Close',
		description: 'Title of Close button inside admin pages sidebar',
	},
});
